var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5309 2.3644C20.7059 2.47259 20.8125 2.6637 20.8125 2.86948V20.682C20.8125 21.0099 20.5467 21.2757 20.2188 21.2757H16.6562C16.3283 21.2757 16.0625 21.0099 16.0625 20.682V18.9007H14.875V20.682C14.875 21.0099 14.6092 21.2757 14.2812 21.2757H3.59375C3.26583 21.2757 3 21.0099 3 20.682V14.1507C3 13.8952 3.16354 13.6683 3.40599 13.5874L10.125 11.3478V7.61948C10.125 7.39458 10.2521 7.18899 10.4532 7.08841L19.9532 2.33841C20.1373 2.24638 20.3559 2.25622 20.5309 2.3644ZM10.125 12.5995L4.1875 14.5787V20.0882H10.125V12.5995ZM11.3125 20.0882H13.6875V18.307C13.6875 17.9791 13.9533 17.7132 14.2812 17.7132H16.6562C16.9842 17.7132 17.25 17.9791 17.25 18.307V20.0882H19.625V3.83018L11.3125 7.98643V20.0882Z",
    fill: "#4F535C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 15.3382H6.5625V16.5257H5.375V15.3382Z",
    fill: "#4F535C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 15.3382H8.9375V16.5257H7.75V15.3382Z",
    fill: "#4F535C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 17.7132H6.5625V18.9007H5.375V17.7132Z",
    fill: "#4F535C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 17.7132H8.9375V18.9007H7.75V17.7132Z",
    fill: "#4F535C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.9632H13.6875V14.1507H12.5V12.9632Z",
    fill: "#4F535C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 12.9632H16.0625V14.1507H14.875V12.9632Z",
    fill: "#4F535C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.3382H13.6875V16.5257H12.5V15.3382Z",
    fill: "#4F535C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 15.3382H16.0625V16.5257H14.875V15.3382Z",
    fill: "#4F535C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.9632H18.4375V14.1507H17.25V12.9632Z",
    fill: "#4F535C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.3382H18.4375V16.5257H17.25V15.3382Z",
    fill: "#4F535C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.5882H13.6875V11.7757H12.5V10.5882Z",
    fill: "#4F535C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 10.5882H16.0625V11.7757H14.875V10.5882Z",
    fill: "#4F535C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10.5882H18.4375V11.7757H17.25V10.5882Z",
    fill: "#4F535C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.21323H13.6875V9.40073H12.5V8.21323Z",
    fill: "#4F535C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 8.21323H16.0625V9.40073H14.875V8.21323Z",
    fill: "#4F535C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.21323H18.4375V9.40073H17.25V8.21323Z",
    fill: "#4F535C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5.83823H18.4375V7.02573H17.25V5.83823Z",
    fill: "#4F535C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.b6e8d7f12c415cbb6ed2a0ece3fde28e.svg";
export { ForwardRef as ReactComponent };